import React from 'react';
import styles from './TableBanners.module.scss';

export function TableEmptyData() {
  return (
    <div className={styles.tableBanner}>
      No data matches the filters you requested.<small>Please refine your filters.</small>
    </div>
  );
}
